import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import withAdminLayout from "../../layout/withAdminLayout";
import { Spin } from "antd";

const Dashboard = lazy(() => import("../../container/finance/Index"));
const FinanceHistory = lazy(() => import("../../container/finance/FinanceHistory"));
const FinanceDetails = lazy(() => import("../../container/finance/FinanceDetails"));


function FinanceRoutes() {
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="finance_history" element={<FinanceHistory />} />
        <Route path="finance_details/:ref" element={<FinanceDetails />} />
        <Route path="*" element={<Navigate to="/asm/finance/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}

export default withAdminLayout(FinanceRoutes);
